import api from '@pray/shared/utils/api';
import type { CursorInfiniteQueryParams } from '@pray/shared/utils/api/types/fetch';

import { GetLeadsListsResponse } from './types';

type GetLeadsListsProps = {
  artistId: string;
  lastItemIdentifier?: string;
  search?: string;
  sortDirection?: 'asc' | 'desc';
};

export async function getLeadsLists({
  artistId,
  lastItemIdentifier,
  search = '',
  sortDirection = 'asc',
}: GetLeadsListsProps) {
  if (!artistId) throw new Error('Artist ID is required');

  const params: CursorInfiniteQueryParams = {};

  if (search) {
    params.search = search;
  }

  if (lastItemIdentifier) {
    params.last_item_identifier = lastItemIdentifier;
  }

  if (sortDirection) {
    params.sort_direction = sortDirection;
  }

  const url = `/web/studio/artists/${artistId}/leads-lists`;
  const response = await api.executeGetRequest<GetLeadsListsResponse>(url, params);

  return response.data;
}
